import { render, staticRenderFns } from "./yxxsc.vue?vue&type=template&id=a24f93ae"
import script from "./yxxsc.vue?vue&type=script&lang=js"
export * from "./yxxsc.vue?vue&type=script&lang=js"
import style0 from "./yxxsc.vue?vue&type=style&index=0&id=a24f93ae&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports